<div class="table__row">
  <div class="table__row__expand">
    <icon
      [name]="expanded ? 'chevron_up' : 'chevron_down'"
      [config]="{ type: 'pointer' }"
      (click)="groupClicked.emit()"
    >
    </icon>
  </div>

  @for (column of _columns; track column) {
    <table-generic-cell
      class="table__cell"
      role="cell"
      [column]="column"
      [data]="data.groupRow"
    >
    </table-generic-cell>
  }
</div>
